import React from "react";
import { FormDataConsumer } from "react-admin";
import SchoolReferenceInput from "./SchoolReferenceInput";

const GameSchoolReferenceInput = ({ type }) => (
  <FormDataConsumer>
    {({ formData, ...rest }) =>
      formData.sportCode &&
      formData.seasonCode && (
        <SchoolReferenceInput formData={formData} type={type} />
      )
    }
  </FormDataConsumer>
);

export default GameSchoolReferenceInput;
